// File: /src/utils/countryUtils.js

import { countryTranslations } from './countryTranslations';

export const getOrderedCountries = () => {
    const collator = new Intl.Collator('pt-BR', {
        sensitivity: 'base',
        ignorePunctuation: true
    });

    const countryArray = Object.entries(countryTranslations)
        .map(([code, country]) => ({
            code,
            name: country.display,
            sortName: country.sort
        }))
        .sort((a, b) => collator.compare(a.sortName, b.sortName));

    return countryArray;
};

export const searchCountry = (query, countries) => {
	const removeAccents = (str) =>
		str
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.toLowerCase();
	const normalizedQuery = removeAccents(query);
	return countries.filter((country) => {
		const normalizedName = removeAccents(country.name);
		return normalizedName.includes(normalizedQuery);
	});
};
